import { convertModeToKey } from './convertModeToKey';
import fixUpHotkeyCommand from 'owa-hotkeys/lib/utils/fixupHotkeyCommand';
import { HotkeyCommand } from 'owa-hotkeys/lib/types/HotkeyCommand';
import { convertHotkeyStringToReadableText } from './convertHotkeyStringToReadableText';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

export function convertHotkeyToReadableText(command: HotkeyCommand) {
    // Get the name of the keyboard shortcuts style the user has enabled.
    const keyboardShortcutsMode = getUserConfiguration().UserOptions.KeyboardShortcutsMode;
    const modeKey = convertModeToKey(keyboardShortcutsMode);
    const fixedCommand = fixUpHotkeyCommand(command)[modeKey];

    return fixedCommand ? convertHotkeyStringToReadableText(fixedCommand) : undefined;
}
